module.exports = function (goalName, data, href) {
    var hasRedirected = false;
    var redirect = function () {
        if (hasRedirected) {
            return;
        }
        hasRedirected = true;
        window.location = href;
    };

    ICF.Modules.Analytics.TrackGoal(goalName, JSON.stringify(data), function () {
        redirect();
    });

    setTimeout(function () {
        redirect();
    }, 500);
};